import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { sanityClient } from "../lib/sanityClient";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const { lang } = useParams();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const query = `*[_type == "category"]{ _id, title, description, slug, icon }`;
        const data = await sanityClient.fetch(query);
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const getLocalizedText = (obj, fallback = "Untitled") =>
    obj?.[lang] || obj?.en || fallback;

  return (
    <section className="py-16 bg-gray-100">
      <h2 className="text-4xl font-bold text-center mb-12">
        {getLocalizedText({ en: "Our Collections", fr: "Nos collections", es: "Nuestras colecciones", ar: "مجموعاتنا" })}
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 px-4 md:px-16">
        {categories.map((category) => (
          <div
            key={category._id}
            className="bg-white rounded-xl shadow-lg p-6 cursor-pointer transform hover:-translate-y-1 hover:shadow-2xl transition-all"
            onClick={() => navigate(`/cm/${lang}/collections/${category.slug?.current}`)}
          >
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full flex-shrink-0 flex items-center justify-center">
                <img
                  src={category.icon}
                  alt={getLocalizedText(category.title)}
                  className="w-12 h-12 rounded-full object-cover"
                />
              </div>
              <div className="ml-4">
                <h3 className="text-2xl font-semibold">
                  {getLocalizedText(category.title)}
                </h3>
              </div>
            </div>
            <p className="text-gray-700 mb-4">
              {getLocalizedText(category.description, "Explore this category.")}
            </p>
            <Link
              to={`/cm/${lang}/collections/${category.slug?.current}`}
              className="block bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors text-center"
              onClick={(e) => e.stopPropagation()}
            >
              {getLocalizedText({ en: "Explore Products", fr: "Voir les produits", es: "Ver productos", ar: "تصفح المنتجات" })}
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryList;
